import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';

export const Container = styled.div`
  padding: 18px 0;
  font-family: 'Roboto', sans-serif;
  color: ${colors.black4};
  line-height: 18px;
  background: ${colors.white};
`;

export const Title = styled.div`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 12px;
  color: ${colors.lightBlack};
`;

export const Subtitle = styled.div`
  font-weight: 500;
  font-size: 10px;
  text-transform: uppercase;
  color: ${colors.darkGray1};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Arrow = styled.img`
  margin: 0 5px;
`;

export const FieldName = styled.span`
  font-weight: 500;
  font-size: 11px;
`;

export const FieldValue = styled.span`
  font-size: 11px;
`;
